import { render, staticRenderFns } from "./ShowFileInfo.vue?vue&type=template&id=74404574&scoped=true&"
import script from "./ShowFileInfo.vue?vue&type=script&lang=js&"
export * from "./ShowFileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74404574",
  null
  
)

export default component.exports